module.exports = __webpack_public_path__ + "img/opdracht-gehaald.7fa9515e.png";